import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import Highcharts from "highcharts/highstock";
import { initModule } from "../../utils/utility";
import HighchartsReact from "highcharts-react-official";
import Loader from "../Loader";
import * as ExportingModule from "highcharts/modules/exporting";
import * as ExportDataModule from "highcharts/modules/export-data";
import NoData from "../Nodata";
import { createChartOptions, CHART_TITLE } from "./constants";

// 3. Initialize
initModule(ExportingModule);
initModule(ExportDataModule);

const LineBarComposedChart = ({ data = {}, loading = false, energyConsumptionData = [] }) => {
  const chartComponentRef = useRef(null);
  const options = createChartOptions(data, energyConsumptionData);

  useEffect(() => {
    if (chartComponentRef.current) {
      chartComponentRef.current.chart.reflow();
    }
  }, [data, energyConsumptionData]);

  const hasData =
    (data?.greenChargingSetpointPower?.length ?? 0) > 0 ||
    (data?.smartChargingSetpointPower?.length ?? 0) > 0 ||
    (energyConsumptionData?.length ?? 0) > 0;

  return (
    <div
      className="relative w-full rounded-lg border border-gray-200 bg-white shadow-md p-4 overflow-hidden"
      style={{ height: "calc(70% - 10px)", flexShrink: 0, display: "flex", flexDirection: "column" }}
    >
      <div style={{ color: "#333", fontWeight: "bold", fontSize: "16px", flexShrink: 0 }}>{CHART_TITLE}</div>
      <div style={{ flex: "1 1 0", minHeight: 0, position: "relative", width: "100%" }}>
        {!loading && !hasData ? (
          <NoData />
        ) : loading ? (
          <div
            className="absolute inset-0 z-10 flex items-center justify-center"
            style={{
              backgroundColor: "rgba(255,255,255,0.7)",
            }}
          >
            <Loader />
          </div>
        ) : (
          <div style={{ width: "100%", height: "100%", minHeight: "300px" }}>
            <HighchartsReact
              highcharts={Highcharts}
              options={options}
              ref={chartComponentRef}
              containerProps={{ style: { width: "100%", height: "100%" } }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

LineBarComposedChart.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool,
  energyConsumptionData: PropTypes.array,
};

export default LineBarComposedChart;
